module.exports = __webpack_public_path__ + "resources/img/img_experdb2_m.0fded8d90d30779250eca650c99f22df.png";